import type { UserPermissionType, UserRoleType } from "avvir";
import { immerable } from "immer";

export class UserRole {
  constructor({
    id,
    roleType,
    scope,
    userId,
    firebaseOrganizationId,
    firebaseProjectId,
    workPackageId
  }: Partial<UserRole>) {
    this.id = id;
    this.roleType = roleType;
    this.scope = scope;
    this.userId = userId;
    this.firebaseOrganizationId = firebaseOrganizationId;
    this.firebaseProjectId = firebaseProjectId;
    this.workPackageId = workPackageId;
  }

  readonly id: number;
  readonly roleType: UserRoleType;
  readonly scope: UserPermissionType;
  readonly userId: number;
  readonly firebaseOrganizationId: string;
  readonly firebaseProjectId: string;
  readonly workPackageId: number;
  private static readonly [immerable] = true;
}
